export const importantLinks = [
    {displayText: 'National Academy Depository', filename: '', link: 'http://www.nad.gov.in'},
    {displayText: 'Vidya Lakshmi Educational Loan', filename: '', link: 'https://www.vidyalakshmi.co.in/'}
];

/* export const academicLinks=[
    {displayText: 'Governing Body', filename: './assets/documentation/academic/GovBody.pdf', link: ''},
    {displayText: 'Gender Sensitization Cell', filename: './assets/documentation/academic/GenderSensitizationCell.pdf', link: ''},
    {displayText: 'Placement & Career Guidance Cell', filename: './assets/documentation/academic/TNP.pdf', link: ''},
    {displayText: 'Anti-Discrimination Cell', filename: './assets/documentation/academic/AntiDiscriminationCell.pdf', link: ''},
    {displayText: 'Anti-Ragging Committee', filename: './assets/documentation/academic/Anti-raggigngcommittee.pdf', link: ''},
    {displayText: 'Last Three Academic Years Results', filename: './assets/documentation/academic/result.pdf', link: ''},

]; */



/* export const newsLetter =[
    {displayText: 'July 2023', filename: './assets/documentation/newsletter/July Month E-News Letter 2023.pdf', link: ''},
    {displayText: 'August 2023', filename: './assets/documentation/newsletter/August Month E-News Letter 2023.pdf', link: ''},
]; */








